import { render, staticRenderFns } from "./Process2.vue?vue&type=template&id=32810db4&scoped=true"
import script from "./Process2.vue?vue&type=script&lang=js"
export * from "./Process2.vue?vue&type=script&lang=js"
import style0 from "./Process2.vue?vue&type=style&index=0&id=32810db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32810db4",
  null
  
)

export default component.exports